import { Button } from "@workspace/web-ui/components/button";
import { Card, CardContent } from "@workspace/web-ui/components/card";
import { LogOut, Trash2 } from "lucide-react";
import { useDeleteModal } from "../store/delete-store";
import { useLogoutModal } from "../store/logout-store";
import { DeleteAccountModal } from "./delete-modal";
import { LogoutConfirmModal } from "./logout-modal";

interface AccountActionsProps {
  logout: () => void;
  deleteAccount: () => void;
}

export const AccountActions = ({logout, deleteAccount}:AccountActionsProps) => {

  const {open: handleOpenLogoutModal} = useLogoutModal()
  const {open: handleOpenDeleteModal} = useDeleteModal()

  const handleLogoutModal = () => { 
    handleOpenLogoutModal()
  }
  const handleDeleteModal = () => { 
    handleOpenDeleteModal()
  }


  return (

    <>
    <Card className="lg:max-w-lg shadow-md rounded-xl">
      <CardContent className="lg:p-6 p-4 space-y-6">
        {/* Sign Out Section */}
        <div className="flex items-center justify-start space-y-2 md:space-y-0 md:justify-between flex-col md:flex-row">
          <div className="flex-1 w-full ">
            <h4 className="text-sm font-medium text-foreground">Sign Out</h4>
            <p className="text-sm text-muted-foreground">You can sign back in anytime.</p>
          </div>
          <Button onClick={ handleLogoutModal} className="bg-[#4272DD] hover:bg-blue-800 text-white rounded-lg px-3 py-5 w-full md:w-[105px]">
            <LogOut className="mr-1 h-4 w-4" />
            Log out
          </Button>
        </div>

        {/* Delete Account Section */}
        <div className="flex items-center justify-start space-y-2 md:space-y-0 md:justify-between flex-col md:flex-row">
          <div className="flex-1 ">
            <h4 className="text-sm font-medium text-foreground">Delete Account</h4>
            <p className="text-sm text-muted-foreground md:max-w-xs">
              Permanently delete your account and all associated data. This action cannot be undone.
            </p>
          </div>
          <Button className="rounded-lg bg-[#E12121] hover:bg-[#a01313] px-3 py-5 w-full md:w-[105px]" onClick={handleDeleteModal} >
            <Trash2 className="mr-1 h-4 w-4" />
            Delete
          </Button>
        </div>
      </CardContent>
    <LogoutConfirmModal logout={logout} />
    <DeleteAccountModal deleteAccount={deleteAccount}/>
    </Card>
    </>
  );
};
